import { Grid, IconButton, Paper, Tab } from '@material-ui/core'
import PlaylistAddCheck from '@material-ui/icons/PlaylistAddCheck'
import { useState } from 'react'
import { AlertList } from '../../core/alerts'
import { AuditDialogue } from '../../core/audit'
import { Alert } from '../../core/domain'
import { withTooltip } from '../../core/format'
import { HospitalistContext } from '../../core/hospitalist-context'
import { IcdCptApi } from '../../core/icd-cpt-api'
import { NdcDialog } from '../../core/ndc'
import { ReturnCollection, ReturnForm } from '../../core/returns'
import { WorksheetApis } from '../../core/visit-context'
import { featureEnabled, isReasonForVisitEnabled, workflows } from '../../core/workflow-api'
import { AddItemLayout } from '../common/add-item'
import { AddNoteDialog } from '../common/notes'
import { TabPanel, WhiteTabs, whiteTabStyle } from '../common/tabs'
import { MipsDialogue } from '../mips/mips'
import { mipsApi } from '../mips/mips-api'
import { ReasonForVisitCollection } from '../reason-for-visit/reason-for-visit'
import { CodingActions } from './coding-actions'
import { CptEditCollection } from './cpt-edit'
import { DownCodeCollection, DownCodeForm } from './downcode'
import { CptCollection, IcdCollection, IcdCptForm, RemoveIcdDialogue } from './icd-cpt'
import { LostRevenueCollection, LostRevenueForm } from './lost-revenue'
import { NCNBCollection, NCNBReaonsForm } from './ncnbreasons'
import { ReviewQuestionCollection, ReviewQuestionForm } from './review-questions'
import { TrackingCodeCollection, TrackingCodeForm } from './tracking-code'
const headerStyle = {
  position: 'sticky',
  top: '0px',
  width: '100%',
  zIndex: 9,
  boxShadow: '0 6px 4px -4px rgba(0,0,0,0.7)',
}
const containerStyle = {
  bottom: 0,
  width: '100%',
  height: '100%',

  overflowX: 'hidden',
  overflowY: 'auto',
}
const messageStyle = {
  color: 'white',
  width: '100%',
  paddingLeft: '12px',
  paddingBottom: '6px',
}

type ScrollTarget = 'alerts' | 'cpt' | 'downcode' | 'ncnbreasons' | 'lostrevenue' | 'tracking' | 'returns' | 'actions'
type WorksheetScroll = {
  ref(target: ScrollTarget): (instance: HTMLDivElement) => void
  scrollTo(target: ScrollTarget): void
}
function worksheetScrollApi(): WorksheetScroll {
  const refs = {
    alerts: null,
    downcode: null,
    ncnbReasons: null,
    lostrevenue: null,
    tracking: null,
    returns: null,
    actions: null,
    cpt: null,
  }

  function ref(target: ScrollTarget) {
    return (el: HTMLDivElement) => (refs[target] = el)
  }
  function scrollTo(target: ScrollTarget) {
    const el: HTMLDivElement = refs[target]
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }
  }
  return {
    ref,
    scrollTo,
  }
}

export const worksheetScroll: WorksheetScroll = worksheetScrollApi()
type WorksheetTabProps = WorksheetApis & {
  hospitalistContext?: HospitalistContext
  alertsV2?: boolean
}

export function WorksheetTab(props: WorksheetTabProps) {
  const {
    context,
    icdCpt,
    reasonForVisit,
    downCode,
    ncnbReasons,
    lostRevenue,
    trackingCode,
    returns,
    reviewQuestions,
    transition,
    alerts,
    edits,
    onTransitionComplete,
    hospitalistContext,
    alertsV2,
  } = props

  const { status, notesApi, ndc, worksheet } = context
  const inlineEdit = true
  const [value, setValue] = useState(0)
  const onChange = (_: any, i: number) => {
    setValue(i)
  }

  icdCpt.onEdit = () => setValue(0)
  downCode.onEdit = () => setValue(1)
  lostRevenue.onEdit = () => setValue(2)
  trackingCode.onEdit = () => setValue(3)
  returns.onEdit = () => setValue(4)
  reviewQuestions.onEdit = () => setValue(5)
  ncnbReasons.onEdit = () => setValue(6)

  transition.getState().onError = () => {
    worksheetScroll.scrollTo('alerts')
  }

  const onClick = () => {
    switch (value) {
      case 0:
        if (reasonForVisit && reasonForVisit.data.getState().enabled) {
          reasonForVisit.form.submit()
          reasonForVisit.clear()
        } else {
          icdCpt.form.submit()
          worksheetScroll.scrollTo('cpt')
        }
        break
      case 1:
        downCode.form.submit()
        worksheetScroll.scrollTo('lostrevenue')
        break
      case 2:
        lostRevenue.form.submit()
        worksheetScroll.scrollTo('actions')
        break
      case 3:
        trackingCode.form.submit()
        worksheetScroll.scrollTo('actions')
        break
      case 4:
        returns.form.submit()
        worksheetScroll.scrollTo('actions')
        break
      case 5:
        reviewQuestions.form.submit()
        worksheetScroll.scrollTo('actions')
        break
      case 6:
        ncnbReasons.form.submit()
        worksheetScroll.scrollTo('ncnbreasons')
    }
  }
  const worksheetStatus = status((s) => s.status)
  const downCodesEnabled = featureEnabled('DownCodes')
  const lostRevenueEnabled = featureEnabled('LostRevenue')
  const trackingCodesEnabled = featureEnabled('WorksheetTrackingCodes')
  const ncnbReasonsEnabled = context.config.ncnbList ? true : false
  const { departmentCode, locationCode, worksheetType } = worksheet
  const reasonForVisitEnabled = worksheetType !== 'PHYSICIAN' && isReasonForVisitEnabled(departmentCode, locationCode)

  const returnsEnabled = true
  const reviewQuestionsEnabled = true

  workflows.data((s) => s.feature)

  const onTransitionFailed = () => {
    worksheetScroll.scrollTo('alerts')
  }

  const onMipsAlert = (a: Alert) => {
    worksheetScroll.scrollTo('alerts')
    mipsApi.getState().setAlert(a)
  }

  if (context.calculator) {
    context.calculator((s) => s.readonly)
  }
  const actions = transition((s) => s.actions)

  const selectedWorksheet = hospitalistContext ? () => hospitalistContext.data.getState().selectedId : null

  return (
    <div
      style={{
        width: '100%',
        height: '90vh',
        display: 'flex',
        flexFlow: 'column',
      }}
    >
      <div style={headerStyle as any}>
        <AddItemLayout onClick={onClick} context={context}>
          <div>
            <WhiteTabs value={value} onChange={onChange}>
              <Tab
                id="icd-cpt"
                label={
                  <Grid container direction="row" alignItems="center" spacing={2}>
                    <Grid item>ICD / CPT</Grid>
                    <Grid item>
                      <ValidateWorksheetIcon {...icdCpt} />
                    </Grid>
                  </Grid>
                }
                style={whiteTabStyle}
              />
              {downCodesEnabled && <Tab id="downcodes" label="Downcodes" style={whiteTabStyle} />}
              {lostRevenueEnabled && <Tab id="lost-revenue" label="Lost Revenue" style={whiteTabStyle} />}
              {trackingCodesEnabled && <Tab id="tracking-codes" label="Tracking Codes" style={whiteTabStyle} />}
              {returnsEnabled && <Tab id="send-backs" label="Provider Queries" style={whiteTabStyle} />}
              {reviewQuestions && <Tab id="review-questions" label="Review Questions" style={whiteTabStyle} />}
              {ncnbReasonsEnabled && <Tab id="ncnbReasons" label="NO CODE / NO BILL" style={whiteTabStyle} />}
            </WhiteTabs>

            <TabPanel value={value} index={0}>
              <IcdCptForm
                icdCpt={icdCpt}
                reasonForVisit={reasonForVisit}
                reasonForVisitEnabled={reasonForVisitEnabled}
              />
              <div style={messageStyle}>{worksheetStatus || ''}</div>
            </TabPanel>
            {downCodesEnabled && (
              <TabPanel value={value} index={1}>
                <DownCodeForm {...downCode} />
                <div style={messageStyle}>{worksheetStatus || ''}</div>
              </TabPanel>
            )}
            {lostRevenueEnabled && (
              <TabPanel value={value} index={2}>
                <LostRevenueForm {...lostRevenue} />
                <div style={messageStyle}>{worksheetStatus || ''}</div>
              </TabPanel>
            )}
            {trackingCodesEnabled && (
              <TabPanel value={value} index={3}>
                <TrackingCodeForm {...trackingCode} />
                <div style={messageStyle}>{worksheetStatus || ''}</div>
              </TabPanel>
            )}
            {returnsEnabled && (
              <TabPanel value={value} index={4}>
                <ReturnForm {...returns} />
                <div style={messageStyle}>{worksheetStatus || ''}</div>
              </TabPanel>
            )}
            {reviewQuestionsEnabled && (
              <TabPanel value={value} index={5}>
                <ReviewQuestionForm {...reviewQuestions} />
                <div style={messageStyle}>{worksheetStatus || ''}</div>
              </TabPanel>
            )}
            {ncnbReasonsEnabled && (
              <TabPanel value={value} index={6}>
                <NCNBReaonsForm {...ncnbReasons} />
                <div style={messageStyle}>{worksheetStatus || ''}</div>
              </TabPanel>
            )}
          </div>
        </AddItemLayout>
      </div>

      <div style={containerStyle as any}>
        <Grid container direction={'column'} spacing={2} style={{ padding: '12px' }}>
          {!alertsV2 && (
            <Grid item style={{ width: '100%' }} ref={worksheetScroll.ref('alerts')}>
              <AlertList api={alerts} edits={edits} onMipsAlert={onMipsAlert} readonly={context.readonly} />
            </Grid>
          )}

          <Grid item ref={worksheetScroll.ref('cpt')}>
            <IcdCollection {...icdCpt} />
          </Grid>

          {reasonForVisitEnabled && (
            <Grid item>
              <ReasonForVisitCollection {...reasonForVisit} />
            </Grid>
          )}

          <Grid item>{inlineEdit ? <CptEditCollection {...icdCpt} /> : <CptCollection {...icdCpt} />}</Grid>
          {downCodesEnabled && (
            <Grid item ref={worksheetScroll.ref('downcode')}>
              <DownCodeCollection {...downCode} />
            </Grid>
          )}
          {lostRevenueEnabled && (
            <Grid item ref={worksheetScroll.ref('lostrevenue')}>
              <LostRevenueCollection {...lostRevenue} />
            </Grid>
          )}
          {trackingCodesEnabled && (
            <Grid item>
              <TrackingCodeCollection {...trackingCode} />
            </Grid>
          )}
          {returnsEnabled && (
            <Grid item>
              <ReturnCollection {...returns} />
            </Grid>
          )}
          {reviewQuestionsEnabled && (
            <Grid item>
              <ReviewQuestionCollection {...reviewQuestions} />
            </Grid>
          )}
          {ncnbReasonsEnabled && (
            <Grid item ref={worksheetScroll.ref('ncnbreasons')}>
              <NCNBCollection {...ncnbReasons} />
            </Grid>
          )}
          <Grid item ref={worksheetScroll.ref('actions')}>
            <br />
            {(context.hospitalist || !context.readonly) && (
              <Paper>
                <CodingActions
                  onComplete={onTransitionComplete}
                  onFailed={onTransitionFailed}
                  transition={transition}
                  actions={actions}
                />
              </Paper>
            )}
          </Grid>
        </Grid>
      </div>

      <AddNoteDialog {...notesApi} selectedWorksheet={selectedWorksheet} />
      <RemoveIcdDialogue />
      <AuditDialogue />
      <MipsDialogue icdCpt={icdCpt} api={mipsApi} alerts={alerts} />
      <NdcDialog {...ndc} />
    </div>
  )
}

function ValidateWorksheetIcon(api: IcdCptApi) {
  return withTooltip(
    'Validate Worksheet',
    <IconButton
      id="validate-worksheet-btn"
      onClick={() => {
        api.validate()
        worksheetScroll.scrollTo('alerts')
      }}
      style={{ width: '8px', height: '8px' }}
    >
      <PlaylistAddCheck fontSize="small" htmlColor="white" />
    </IconButton>,
  )
}
